import SectionTitle from "./SectionTitle";

const features = [
  { icon: "ri-smartphone-line", title: "Dedicated ACE96 AUS APP", body: "Download the official ACE96 AUS APP for iOS and Android. Every deposit made through the app comes with a random bonus reward. Available at www.ace96au.co. No lag at all — runs perfectly on iPhone and Android." },
  { icon: "ri-global-line", title: "Full Browser Access", body: "No app? No problem. Access the full range of 4000+ games and all platform features directly through your mobile browser with no downloads required." },
  { icon: "ri-speed-line", title: "Fast Loading & Smooth Gameplay", body: "Optimised for Australian mobile networks. Enjoy quick game launches, smooth animations, and zero lag whether you're on 4G, 5G, or WiFi." },
  { icon: "ri-lock-line", title: "Secure Mobile Transactions", body: "Deposit via PayID, Google Pay, Apple Pay, Amopay, or Speedpay directly from your phone. All transactions are protected with 256-bit SSL encryption on mobile." },
  { icon: "ri-gift-line", title: "Every Deposit Random Bonus", body: "Every deposit made through the ACE96 AUS APP earns a random bonus reward. The more you deposit, the more surprises you unlock. Download the app today and start earning." },
  { icon: "ri-download-line", title: "Easy App Download", body: "Download the ACE96 AUS APP directly from www.ace96au.co. No app store required. Simple installation for both iOS and Android devices in seconds." },
];

export default function MobileGambling() {
  return (
    <section id="mobile" className="py-12">
      <SectionTitle>Mobile Gambling</SectionTitle>

      <p className="text-slate-300 leading-relaxed mb-8 text-sm">
        Experience the thrill of gaming on the go with the Ace96au mobile platform. The dedicated ACE96 AUS APP brings Asia's Biggest Online Casino to your fingertips — with every deposit earning a random bonus reward. Available for iOS and Android. No lag, smooth gameplay, and full access to all 4000+ games.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
        {features.map((f, i) => (
          <div key={i} className="glass-card rounded-2xl p-5 flex items-start gap-4 transition-all duration-300 hover:scale-[1.01] cursor-default">
            <div
              className="w-11 h-11 flex items-center justify-center rounded-xl flex-shrink-0"
              style={{
                background: "linear-gradient(135deg, rgba(16,92,232,0.2), rgba(16,92,232,0.1))",
                border: "1px solid rgba(16,92,232,0.25)",
              }}
            >
              <i className={`${f.icon} text-xl`} style={{ color: "#105CE8" }}></i>
            </div>
            <div>
              <strong className="text-white font-semibold text-sm block mb-1">{f.title}</strong>
              <p className="text-slate-400 text-xs leading-relaxed">{f.body}</p>
            </div>
          </div>
        ))}
      </div>

      <p className="text-slate-400 text-sm leading-relaxed">
        With Ace96au, your gaming adventure never pauses. The mobile platform brings Asia's Biggest Online Casino to your fingertips — whether you're at home, commuting, or anywhere in between. Download the ACE96 AUS APP today and claim your random deposit bonus. Every deposit is a chance to win big.
      </p>
    </section>
  );
}
